import { render, staticRenderFns } from "./notEnoutgh.vue?vue&type=template&id=1d503f18&scoped=true&"
import script from "./notEnoutgh.vue?vue&type=script&lang=js&"
export * from "./notEnoutgh.vue?vue&type=script&lang=js&"
import style0 from "./notEnoutgh.vue?vue&type=style&index=0&id=1d503f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d503f18",
  null
  
)

export default component.exports